module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"nl-BE":{"help_me":"Help me, ik ben geblokkeerd!","FAQ":"Meer informatie"},"en-BE":{"help_me":"Help me, I am blocked!","FAQ":"FAQ"},"fr-BE":{"help_me":"Aidez-moi, je suis bloqué !","FAQ":"FAQ"}}')
  delete Component.options._Ctor
}
